// @ts-ignore
import Keycloak from 'keycloak-js';

const subdomain = window.location.host.split('.')[0];

let config = {
  url: import.meta.env.VITE_KEYCLOAK_URL,
  realm: 'myrealm',
  clientId: 'location',
};

if (subdomain === 'backoffice') {
  config = {
    url: import.meta.env.VITE_KEYCLOAK_URL,
    realm: 'myrealm',
    clientId: 'backoffice',
  };
} else if (subdomain === 'advertiser') {
  config = {
    url: import.meta.env.VITE_KEYCLOAK_URL,
    realm: 'myrealm',
    clientId: 'advertiser',
  };
} else if (subdomain === 'services') {
  config = {
    url: import.meta.env.VITE_KEYCLOAK_URL,
    realm: 'myrealm',
    clientId: 'services',
  };
}

const keycloak = new Keycloak(config);

export const initOptions = {
  onLoad: 'check-sso',
  flow: 'standard',
  pkceMethod: 'S256',
  silentCheckSsoRedirectUri: `${window.location.origin}/silent-check-sso.html`,
  checkLoginIframe: true,
  checkLoginIframeInterval: 30,
  enableLogging: true,
};

export default keycloak;
